import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

import { putChannel } from '../../../api/channels';

import { generateChannelCIDKey } from '../../../utils/generateChannelCIDKey';
import { mergeChannelWithUserData } from '../../../utils/channels';
import {
  checkAndSetLoadingWithId,
  handleRequestRejection,
  onMatchedRequest,
} from '../../../utils/asyncThunkRequest';

import { REQUEST } from '../../../constants/request';

export const updateChannel = createAsyncThunk(
  'channels/updateChannel',
  async ({ path, body, params }, { signal, rejectWithValue }) => {
    const source = axios.CancelToken.source();
    signal.addEventListener('abort', () => {
      source.cancel();
    });

    try {
      const [channelResponse, channelUserDataResponse] = await putChannel(
        { path, body, params },
        {
          cancelToken: source.token,
        },
      );

      return mergeChannelWithUserData(channelResponse, channelUserDataResponse);
    } catch (error) {
      return rejectWithValue(error.response.status);
    }
  },
  {
    condition: ({ path }, { getState }) => {
      const state = getState();

      return !(
        state.channels.channels.channel.actions.update.request[
          generateChannelCIDKey(path)
        ]?.loading === REQUEST.pending
      );
    },
  },
);

export const updateChannelExtraReducers = builder => {
  builder
    .addCase(updateChannel.pending, (state, action) => {
      checkAndSetLoadingWithId(
        state.channels.channel.actions.update.request,
        action,
        generateChannelCIDKey(action.meta.arg.path),
      );
    })
    .addCase(updateChannel.fulfilled, (state, action) => {
      const channelCIDKey = generateChannelCIDKey(action.meta.arg.path);

      onMatchedRequest(
        state.channels.channel.actions.update.request[channelCIDKey],
        action,
        () => {
          state.channels.channel.byId[channelCIDKey] = action.payload;
        },
      );
    })
    .addCase(updateChannel.rejected, (state, action) => {
      handleRequestRejection(
        state.channels.channel.actions.update.request[
          generateChannelCIDKey(action.meta.arg.path)
        ],
        action,
      );
    });
};
